export const colors = {
  primary: "#003865",
  secondary: "#00c1d4",
  headerbk: "#060F9F",
  skyblue: "#4CC9E9",
  white: {
    main: "#fff",
  },
  black: {
    main: "#000",
  },
  yellow: {
    main: "#FEDC90",
    dark: "#FCB71C",
    secondary: "#FFA300",
  },
  red: {
    main: "#ff0000",
    light: "#123456",
  },
  green: {
    main: "#0F850F",
    dark: "#123456",
    button: "#24707E",
  },
  gray: {
    main: "#00000029",
    text: "#5c5c5c",
    light: "#fafafa",
    border: "#aca9a9",
    tablebg: "#d9d8d6",
    text2: "#707070",
    divider: "#bebebe",
    light2: "#788392",
  },
  blue: {
    lightText: "#2c8b9e",
  },
  purple: {
    main: "#4A0F8C",
  },
};
